/**
 * Liquidity Analysis (FSD Part 3, 3.2.1 FIN-T01-R019) — available liquidity
 * per legal entity with every deduction shown. The wiring packet spreads
 * `TREASURY_LIQUIDITY_ROUTES` beside `TREASURY_ROUTES` (nav p03 id
 * `treasury-liquidity`, fsd 3.2.1, code R019).
 *
 * Gated on `treasury.position.read`, what
 * `GET /treasury-positions/available-liquidity` declares.
 */

import type { RouteRecordRaw } from 'vue-router'

import { TREASURY_PERMISSIONS } from '@/modules/treasury/permissions'

export const TREASURY_LIQUIDITY_PATH = '/treasury/liquidity'

export const TREASURY_LIQUIDITY_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_LIQUIDITY_PATH,
    name: 'treasury-liquidity',
    component: () => import('@/modules/treasury/liquidity/LiquidityView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.liquidity',
      permission: TREASURY_PERMISSIONS.positionRead,
    },
  },
]
